export const smoothScrollTo = (targetId) => {
  const target = document.getElementById(targetId);
  if (!target) return;

  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 1000;
  let start = null;

  const easeInOutExpo = (t) => {
    return t === 0
      ? 0
      : t === 1
      ? 1
      : t < 0.5
      ? Math.pow(2, 20 * t - 10) / 2
      : (2 - Math.pow(2, -20 * t + 10)) / 2;
  };

  const animate = (timestamp) => {
    if (!start) start = timestamp;
    const timeElapsed = timestamp - start;
    const progress = Math.min(timeElapsed / duration, 1);
    const ease = easeInOutExpo(progress);

    window.scrollTo(0, startPosition + distance * ease);

    if (timeElapsed < duration) requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
};
